import React from "react";
import Alert from "alerts/alert_summary/Alert";
import { Button } from "react-bootstrap";

class AlertContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			alerts: this.props.alerts,
		};
	}

	resolveAll = () => {
		let ids = [];
		let alerts = this.state.alerts.map((alert) => {
			ids.push(alert.id);
			let alertTemp = alert;
			alertTemp.resolved = true;
			return alertTemp;
		});
		this.setState({ alerts: alerts });
		this.props.resolveAll(ids, false);
	};

	render() {
		let alerts = this.state.alerts.map((alert) => {
			let section = capitalize(alert.alert_type.toLowerCase());
			if (section == "Seo") {
				section = "SEO";
			}
			let shouldRender = false;
			if (
				section == "SEO" &&
				this.props.userSubscriptions[this.props.companyName].showSeo
			) {
				shouldRender = true;
			} else if (
				section == "Search" &&
				this.props.userSubscriptions[this.props.companyName].showSearch
			) {
				shouldRender = true;
			} else if (
				section == "Social" &&
				this.props.userSubscriptions[this.props.companyName].showSocial
			) {
				shouldRender = true;
			} else if (
				section == "Display" &&
				this.props.userSubscriptions[this.props.companyName].showDisplay
			) {
				shouldRender = true;
			} else if (
				section == "Video" &&
				this.props.userSubscriptions[this.props.companyName].showVideo
			) {
				shouldRender = true;
			}

			if (shouldRender == true) {
				return (
					<Alert
						key={alert.id}
						alert={alert}
						resolveAlert={this.props.resolveAlert}
						snoozeAlert={this.props.snoozeAlert}
					/>
				);
			}
		});
		let companyLogo = this.props.logos[this.props.companyName];
		return (
			<>
				<div className="alert-container d-flex flex-column flex-md-row off-color-bg">
					<div className="logo alert-mobile mx-auto my-3 align-items-center d-flex flex-column">
						<div className="text-center">
							{companyLogo ? (
								<img className="alert-company-avatar" src={companyLogo} />
							) : (
								<h5 className="company-name">{this.props.companyName}</h5>
							)}
						</div>
						<Button
							variant="success"
							className="ml-auto mr-auto height-min-content"
							onClick={this.resolveAll}
						>
							<i className="fas fa-check"></i>
							Resolve All
						</Button>
					</div>
					<div className="alerts table-responsive">
						<table className="alert-summary-table table">
							<tbody>{alerts}</tbody>
						</table>
					</div>
				</div>
			</>
		);
	}
}

export default AlertContainer;
